'use client';

import { prefix } from '@util/imagePrefix';
import Image from 'next/image';
import Link from 'next/link';
import AektivTradeInModal from './aektivTradeInModal';
import { useState } from 'react';
import MobileAektivTradeInModal from './mobileAektivTradeInModal';
import { isMobile } from '@util/index';

export const UpgradeGearSection = () => {
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [mobileUpgradeModalOpen, setMobileUpgradeModalOpen] = useState(false);

  return (
    <div className="relative flex h-[54rem] w-full flex-col gap-y-8 rounded-[2rem] bg-white pb-16 sm:mx-auto sm:h-[30rem] sm:max-w-[150rem] sm:flex-row sm:gap-y-0 sm:pb-0">
      <Image
        src={`${prefix}/assets/aektiv-upgrade-page-section_1920x2560.png`}
        alt="Aektive Gear Trade-in Program"
        className="absolute -top-32 h-auto w-full sm:bottom-0 sm:left-32 sm:top-auto sm:h-[40rem] sm:w-auto"
        height={400}
        width={900}
      />

      <div className="flex h-full w-full flex-col justify-end sm:flex-row sm:pr-32">
        <div className="flex h-full flex-col items-center justify-end gap-y-8 sm:items-start sm:justify-center">
          <div className="flex flex-col items-center gap-y-2 sm:items-start">
            <span className="text-[3.1rem] font-bold text-black">
              Upgrade your gear today!
            </span>

            <p className="w-[40rem] text-center text-[1.8rem] font-medium text-zinc-600 sm:w-[50rem] sm:text-start">
              Get a seamless trade-in experience that benefits both you and the
              riding community.
            </p>
          </div>

          <button
            type="button"
            className="min-h-[5rem] rounded-[1.5rem] bg-brand-secondary px-6 py-4 text-[2.1rem] font-medium capitalize text-white transition-colors duration-150 hover:bg-brand-secondary-darker"
            onClick={() => {
              if (isMobile()) {
                setMobileUpgradeModalOpen(true);
              } else {
                setUpgradeModalOpen(true);
              }
            }}
          >
            get your offer now!
          </button>
        </div>
      </div>

      <AektivTradeInModal
        open={upgradeModalOpen}
        dismiss={() => setUpgradeModalOpen(false)}
      />

      <MobileAektivTradeInModal
        open={mobileUpgradeModalOpen}
        dismiss={() => setMobileUpgradeModalOpen(false)}
      />
    </div>
  );
};
